
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psychics/[slug]",
      function () {
        return require("private-next-pages/psychics/[slug].tsx");
      }
    ]);
  